import { P } from "@/components/ui/Heading";
import { Property } from "@/interfaces/property.interface";
import {
  getPlaceholdJPUrl,
  getTextColorForBackground,
  isColorWhite,
} from "@/lib/agency-gradient";
import clsx from "clsx";
import Image from "next/image";

export interface PremiumCardHeaderHeaderProps {
  property: Property;
  index: number;
}

export const PremiumCardHeader = (props: PremiumCardHeaderHeaderProps) => {
  const { property, index } = props;

  const agentNameFallback = property.agent?.name
    ? property.agent?.name[0]
    : "A";

  const textColor = getTextColorForBackground(property.agency.color ?? "black");

  return (
    <div
      className={clsx("flex h-12 w-full items-center justify-between px-2", {
        "border-b": isColorWhite(property.agency.color!),
      })}
      style={{
        background: property.agency.color,
      }}
    >
      <div className="relative h-full w-28 rtl:ml-2 ltr:mr-2">
        <Image
          fill
          src={
            property.agency?.logo ??
            getPlaceholdJPUrl(
              property.agency.name,
              property.agency.color,
              textColor,
              100,
              "1000x100"
            )
          }
          className="rounded-md object-contain transition-transform duration-300 hover:scale-105"
          alt={property.agency?.name}
          quality={100}
          priority
          loading={index === 0 ? "eager" : "lazy"}
          sizes="(max-width: 768px) 40vw, 20vw"
          fetchPriority={index === 0 ? "high" : "low"}
        />
      </div>

      <div className="flex items-center gap-2 h-full rtl:ml-5 ltr:mr-5">
        <P
          className={clsx(
            "hidden md:block mt-3 text-sm font-semibold line-clamp-1 sm:text-base",
            {
              "text-white": textColor === "#fff",
              "text-black": textColor === "#000",
            }
          )}
        >
          {property.agent?.name}
        </P>
        <div className="relative mt-10 ltr:-mr-4 rtl:-ml-4 z-10 h-12 w-12 sm:h-[4.5rem] sm:w-[4.5rem]">
          <Image
            src={
              property.agent?.photo ??
              getPlaceholdJPUrl(
                agentNameFallback,
                property.agency.color,
                textColor,
                100
              )
            }
            className="rounded-full object-top object-cover border aspect-auto"
            alt={property.agent?.name}
            fill
            loading={index === 0 ? "eager" : "lazy"}
            sizes="(max-width: 768px) 20vw, 5vw"
            unoptimized={!Boolean(property.agent?.photo)}
            fetchPriority={index === 0 ? "high" : "low"}
          />
        </div>
      </div>
    </div>
  );
};
